import type { LocationQuery } from 'vue-router';

import { EntryCta, EntrySource } from '~/graphql/generated/graphql';

export const ENTRY_SOURCE = {
  ROOT_UNIFIED: EntrySource.RootUnified,
  ROOT_UNIFIED_LEARN: EntrySource.RootUnifiedLearn,
  ROOT_UNIFIED_CAREER_ADVICE: EntrySource.RootUnifiedCareerAdvice,
  ABOUT: EntrySource.About,
  JOB_PAGE: EntrySource.JobPage,
  CAREER_PAGE: EntrySource.CareerPage,
  ARTICLE_PAGE: EntrySource.ArticlePage,
  LEARNING_ASSET_COMPLETION: EntrySource.LearningAssetCompletion,
  HUB_PAGE: EntrySource.HubPage,
  VIDEO_PAGE: EntrySource.VideoPage,
  INSTITUTION_PAGE: EntrySource.InstitutionPage,
  COURSE_PAGE: EntrySource.CoursePage,
} as const;

export const ENTRY_CTA = {
  HEADER_SIGNUP: EntryCta.HeaderSignup,
  HERO_CTA: EntryCta.HeroCta,
  FIND_A_FUTURE: EntryCta.FindAFuture,
  GET_LIFE_READY: EntryCta.GetLifeReady,
  YOUR_THING: EntryCta.YourThing,
  VIRTUAL_CAREER: EntryCta.VirtualCareer,
  TRENDING_EXPERIENCES: EntryCta.TrendingExperiences,
  CHAT_WITH_COACH: EntryCta.ChatWithCoach,
  START_CHATTING: EntryCta.StartChatting,
  SAVE_COINS: EntryCta.SaveCoins,
  COMPLETION_SIGNUP: EntryCta.CompletionSignup,
} as const;

export interface EntryTrackingParams {
  entrySource: EntrySource | null;
  entryCta: EntryCta | null;
}

export const ENTRY_TRACKING_QUERY_PARAM = 'entryTracking';

export const buildEntryTrackingQueryString = (entrySource: EntrySource | string, entryCta: EntryCta | string): string => {
  const encoded = btoa(JSON.stringify({ entrySource, entryCta }));
  return `${ENTRY_TRACKING_QUERY_PARAM}=${encodeURIComponent(encoded)}`;
};

const validEntrySources = new Set<string>(Object.values(EntrySource));
const validEntryCtas = new Set<string>(Object.values(EntryCta));

export const parseEntryTrackingFromQuery = (query: LocationQuery): EntryTrackingParams => {
  const encoded = typeof query[ENTRY_TRACKING_QUERY_PARAM] === 'string' ? query[ENTRY_TRACKING_QUERY_PARAM] : null;
  if (!encoded) {
    return { entrySource: null, entryCta: null };
  }

  try {
    const parsed = JSON.parse(atob(encoded));
    return {
      entrySource: validEntrySources.has(parsed.entrySource) ? (parsed.entrySource as EntrySource) : null,
      entryCta: validEntryCtas.has(parsed.entryCta) ? (parsed.entryCta as EntryCta) : null,
    };
  }
  catch {
    return { entrySource: null, entryCta: null };
  }
};
